import type { ComponentProps, FC } from 'react';

import { PersonalizationCard as SharedPersonalizationCard } from '@shared/products-components';

import { PersonalizationAvatar } from './components/PersonalizationAvatar';
import { useActivePAPIProduct } from '../../ActivePAPIProductContext';

type Props = Pick<ComponentProps<typeof SharedPersonalizationCard>, 'actions'> & {
    'data-cy': string;
};

export const PersonalizationCard: FC<Props> = ({ actions, 'data-cy': dataCy }) => {
    const {
        localizedName,
        _embedded: {
            customization: { name },
        },
    } = useActivePAPIProduct();

    return (
        <SharedPersonalizationCard
            actions={actions}
            avatar={<PersonalizationAvatar />}
            subtitle={localizedName}
            alias={name}
            data-cy={dataCy}
        />
    );
};
